<template>
  <el-dialog
    v-el-drag-dialog
    :close-on-click-modal="false"
    :show-close="false"
    :visible.sync="innerVisible"
    :title="$t('Message.SelectDepartment')"
    width="300px"
  >
    <el-form label-width="80px" label-position="left" style="width: 100%">
      <cargo-advance-select
        no="departmentId"
        :select-type="selectTypeNames.basic_data_Department"
        :allow-create="true"
        filterable
        :cache="false"
        :static-options="departmentArray"
        @parentCallBack="p=>{departmentId = p.departmentId}"
      />
    </el-form>
    <span slot="footer">
      <el-button type="primary" no="confirm" @click="clickHandler">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
      <el-button v-show="showCancelBtn" type="primary" no="cancel" @click="cancelClickHandler">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>

import { getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'

export default {
  name: 'DepartmentChooserDialog',
  components: { cargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    departments: { type: Array, default: null },
    showCancelBtn: { type: Boolean, default: true }
  },
  data() {
    return {
      innerVisible: false,
      selectTypeNames: TYPE_NAMES,
      departmentId: 0,
      departmentArray: []
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.initData()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.departmentId = 0
        this.departmentArray = []
      }
    }
  },
  methods: {
    initData() {
      this.departmentArray = []
      if (this.$store.getters.isAdmin) {
        const departments = getCacheListByKey(basicCacheKeys.basic_data_Department)
        if (departments && departments.length > 0) {
          const officeUuid = this.$store.getters.currentOffice.uuid
          this.departmentArray = departments.filter(p => p.officeUuid === officeUuid)
        }
      } else {
        if (this.departments && this.departments.length > 0) {
          this.departmentArray = this.departments
        }
      }
    },
    clickHandler() {
      if (!this.departmentId) {
        this.$message.warning(this.$t('Message.PleaseSelectADepartment'))
        return
      }
      this.$emit('callback', this.departmentId)
    },
    cancelClickHandler() {
      this.$emit('callback', null)
    }
  }
}
</script>

<style scoped>
</style>
